import { useEffect, useState } from 'react';
import { fetchProjects } from './contentApi';

let projectsCache = null;
let projectsPromise = null;

/** Uma chamada à API; reutilizada pelo hook e pela página Projetos. */
export function loadProjects() {
  if (projectsCache) {
    return Promise.resolve(projectsCache);
  }

  if (!projectsPromise) {
    projectsPromise = fetchProjects()
      .then((projects) => {
        projectsCache = Array.isArray(projects) ? projects : [];
        return projectsCache;
      })
      .catch(() => {
        projectsCache = [];
        return projectsCache;
      });
  }

  return projectsPromise;
}

export function useProjectsVisible() {
  const [state, setState] = useState({ visible: false, loading: true });

  useEffect(() => {
    let active = true;

    loadProjects().then((projects) => {
      if (active) {
        setState({ visible: projects.length > 0, loading: false });
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return state;
}
